import * as Schema from "effect/Schema";

/**
 * TextWidget — wraps a Lexical EditorState serialized to JSON. The
 * shape is opaque to us (duro-lexical-multi owns it), but we type the
 * outer envelope so dispatch by `contentType` works. The materialize
 * step (T3.1) calls `serializeToHtml(editorState, theme)` from
 * duro-lexical-multi@0.2.0 (the S4 spike's output) to render.
 *
 * EditorStateJson stores the raw `EditorState.toJSON()` shape, which
 * contains a recursive `root.children` tree. We accept any JSON
 * object — duro-lexical-multi validates internally.
 */
import { LexicalEditorStateJson } from "./lexical-state.js";

export const TextWidgetContent = Schema.Struct({
  contentType: Schema.Literal("text"),
  editorState: LexicalEditorStateJson,
});
export type TextWidgetContent = Schema.Schema.Type<typeof TextWidgetContent>;
